import { h, FunctionalComponent, ComponentChildren } from "preact";

//import SwiperDefault from 'swiper'
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper as SwiperWidget, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.css';

import { useState } from "preact/hooks";
import styled from 'styled-components';

interface CarouselProps {
  children?: ComponentChildren,
  indexCarouselRef: number,
  spaceBetween: number,
  breakpoints?: {
    slidesPerViewLg: number,
    slidesPerViewMd: number,
    slidesPerViewSm: number
  }
}

// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const SwiperContainer = styled.div`
  margin-bottom: 48px;
  padding: 0 30px;
  position: relative;

  @media screen and (max-width: 600px) {
    padding: 0 13px;
  }

  .swiper-container {
    @media screen and (max-width: 769px) {
      overflow: inherit;
    }
  }

  .swiper-pagination-bullets, .swiper-pagination {
    position: relative;
    bottom: 0;
    margin-bottom: 20px;
  }

  .swiper-pagination.swiper-pagination-bullets .swiper-pagination-bullet {
    opacity: 0.2;
  }

  .swiper-pagination.swiper-pagination-bullets .swiper-pagination-item-active {
    opacity: 1;
    background: black;
  }

  .swiper-pagination .swiper-pagination-bullet {
    opacity: 0;
  }
`;

const SwiperNavButton = styled.div`
  width: 10px;
  height: 16px;
  position: absolute;
  top: 50%;
  margin-top: 10px;
  cursor: pointer;
  @media screen and (max-width: 600px) {
    display: none;
  }
`;
const SwiperNextNavButton = styled(SwiperNavButton) <{ active: boolean }>`
  right: 10px;
  opacity: ${p => (p.active ? 1 : 0)};
`;

const SwiperPrevNavButton = styled(SwiperNavButton) <{ active: boolean }>`
  left: 10px;
  opacity: ${p => (p.active ? 1 : 0)};
`;

export let SwiperRefs: Swiper[] = [];
export const Carousel: FunctionalComponent<CarouselProps> = ({ children, indexCarouselRef, spaceBetween, breakpoints }) => {
  const [slidesPerView, setSlidesPerView] = useState(3);
  const [isNextNavButtonActive, setIsNextNavButtonActive] = useState(true);
  const [isPrevNavButtonActive, setIsPrevNavButtonActive] = useState(true);
  return (
    <SwiperContainer className="swiper-global-container">
      <SwiperNextNavButton active={isNextNavButtonActive} onClick={() => SwiperRefs[indexCarouselRef].slideNext()}>
        <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 14L8 8L2 2" stroke="black" stroke-width="3" />
        </svg>
      </SwiperNextNavButton>
      <SwiperPrevNavButton active={isPrevNavButtonActive} onClick={() => SwiperRefs[indexCarouselRef].slidePrev()}>
        <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 2L3 8L9 14" stroke="black" stroke-width="3" />
        </svg>
      </SwiperPrevNavButton>

      <SwiperWidget
        preventClicks={false}
        preventClicksPropagation={false}
        spaceBetween={spaceBetween}
        slidesPerView={slidesPerView}
        slidesPerGroup={3}
        pagination={{ clickable: true, bulletActiveClass: 'swiper-pagination-item-active' }}
        breakpoints={{
          "@0.00": {
            "slidesPerView": 'auto',
            "spaceBetween": 10,
            "slidesPerGroup": breakpoints?.slidesPerViewSm || 1,
            "grabCursor": true,
            "centeredSlides": true
          },
          "@0.75": {
            "slidesPerView": breakpoints?.slidesPerViewMd || 2,
            "slidesPerGroup": 2,
            "spaceBetween": 20
          },
          "@1.00": {
            "slidesPerView": breakpoints?.slidesPerViewMd || 3,
            "spaceBetween": 20
          },
          "@1.50": {
            "slidesPerView": breakpoints?.slidesPerViewLg || 3,
            "spaceBetween": 20,
            "scrollbar": {
              draggable: false
            }
          }
        }}
        onUpdate={(swiper) => {
          SwiperRefs[indexCarouselRef] = swiper;
        }}
        onSwiper={(swiper) => {
          setIsPrevNavButtonActive(false);
          if (swiper.pagination.bullets?.length === 1) {
            swiper.pagination.destroy();
          }
          swiper.update();
        }}
        onSlideChange={(swiper) => {
          if (!(swiper.isBeginning || swiper.isEnd)) {
            if (swiper.pagination.bullets?.length > 1) {
              setIsPrevNavButtonActive(true);
              setIsNextNavButtonActive(true);
            }
          }
        }}
        onReachBeginning={(swiper) => {
          setIsPrevNavButtonActive(false);
          if (swiper.pagination.bullets?.length > 1) {
            setIsNextNavButtonActive(true);
          }
        }}
        onReachEnd={(swiper) => {
          setIsNextNavButtonActive(false)
          if (swiper.pagination.bullets?.length > 1) {
            setIsPrevNavButtonActive(true)
          }
        }}
      >
        {children}
      </SwiperWidget>
    </SwiperContainer>
  )
}